<div class="login-route">


  <div class="login-options" *ngIf="!(authenticating$ | async)">
    <p>
      Choisissez comment vous identifier
    </p>
    <ng-template [ngIf]="showItsme && itsmeAvaialable">
      <cf-itsme-login-bloc></cf-itsme-login-bloc>
    </ng-template>
    <ng-template [ngIf]="showMail">
      <cf-mail-link-bloc></cf-mail-link-bloc>
    </ng-template>
    <ng-template [ngIf]="showPassword">
      <cf-password-bloc></cf-password-bloc>
    </ng-template>
  </div>

  <div class="loading-bloc lifeislife-loading-bloc" *ngIf="authenticating$ | async">
    <div class="logo">
      <div class="loader"></div>
      <div class="image"></div>
    </div>
    <h1>
      Vérification de la session...
    </h1>
  </div>

</div>
